import { Settings } from "@vibe/icons";
import { IconButton } from "@vibe/core";
import { MondayApiQueryInstance } from "../../../services/monday/monday-service-ts";

const SettingsDrawer = () => {
  const handleSettingsOpenModal = async () => {
    await MondayApiQueryInstance.openAppFeatureModal("/settings", null, "31.063rem", "56.125rem");
  };

  return (
    <div>
      <IconButton onClick={() => handleSettingsOpenModal()} icon={Settings} size="medium" tooltipContent="Settings" kind={IconButton.kinds.SECONDARY} />

      {/* <Drawer open={open} anchor="right" onClose={() => toggleDrawer(false)}>
        <SettingsDrawerList
          switchValues={switchValues}
          setSwitchValues={setSwitchValues}
          handleCloseDrawer={toggleDrawer}
          mutate={mutate}
          isLoading={isLoading}
          itemSettings={itemSettings}
        />
      </Drawer> */}
    </div>
  );
};

export default SettingsDrawer;
